import React from 'react';

import styles from './info-message.module.scss';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

interface Props {
	message: string;
}

const InfoMessage = ({ message }: Props) => {
	return (
		<div className={styles.infoMessage}>
			<BringgIcon iconName={BringgFontIcons.CircleExclamation} className={styles.exclamationIcon} /> {message}
		</div>
	);
};

export default InfoMessage;
